let tabTitles = document.querySelectorAll('.tab-items');
let tabContent = document.querySelectorAll('.tab-content');

tabTitles.forEach(function(tabTitle,index) {
  tabTitle.addEventListener('click', function() {
  
    tabTitles.forEach(function(tabTitle) {
      tabTitle.classList.remove('active')
    })
    this.classList.add('active');
    
    tabContent.forEach(function(item) {
      item.classList.add('hidden');
    });
    
    let target = this.getAttribute('data-target');
    document.getElementById(target).classList.remove('hidden'); 
    
  });
});
